import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('team-members-picker',{on:{"select":_vm.onTeamMembersSelect},scopedSlots:_vm._u([{key:"trigger",fn:function({ on }){return [_c('base-button',_vm._g({attrs:{"secondary":"","small":""}},on),[_c(VIcon,{attrs:{"left":"","small":""}},[_vm._v("mdi-account-plus-outline")]),_vm._v(" Add Members ")],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }